import React, { ReactElement } from 'react';

import { classNames } from 'utils/css';
import throttle from 'lodash.throttle';
import { TButtonProps } from './Button.types';
import {
  BUTTON_HTML_TYPE,
  BUTTON_VARIANT,
  THROTTLE_TIME,
} from './Button.constants';
import styles from './Button.module.scss';

function Button({
  variant = BUTTON_VARIANT.primary,
  htmlType = BUTTON_HTML_TYPE.button,
  disabled,
  onClick,
  children,
  block,
  ...restProps
}: TButtonProps): ReactElement {
  const className = classNames(
    styles.btn,
    variant && styles[variant],
    block && styles.fullWidth,
    restProps.className
  );

  const onPress =
    onClick &&
    throttle(onClick, THROTTLE_TIME, { leading: true, trailing: false });

  return (
    <button
      data-testid="Button"
      // eslint-disable-next-line react/button-has-type
      type={htmlType}
      disabled={disabled}
      onClick={onPress}
      {...restProps}
      className={className}>
      {children}
    </button>
  );
}

export { Button };
